import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Project } from "src/app/model/form/project";
import { ProjectSummaryResponse } from "src/app/model/response/ProjectSummaryResponse";
import { ProjectService } from "src/app/service/project.service";
import { ImageUrlService } from "src/app/service/image-url.service";
import { DEFAULT_IMAGE } from "src/app/model/mockup/image-mockup";
import { Router } from "@angular/router";

@Component({
  selector: "app-card-inauguration-project",
  templateUrl: "./card-inauguration-project.component.html",
  styleUrls: ["./card-inauguration-project.component.css"],
})
export class CardInaugurationProjectComponent implements OnInit {
  @Input() project: ProjectSummaryResponse | undefined;
  @Input() bkpProject: Project | undefined;
  @Input() user: string | null = "";
  @Input() shared: boolean | null = false;
  @Input() detail: boolean | null = false;

  @Output() actionFromCard = new EventEmitter<void>();
  @Output() toggleFavoriteButton = new EventEmitter<void>();

  imageStyle: any;

  constructor(private projectService: ProjectService, private imageUrlService: ImageUrlService, private router: Router) {}

  ngOnInit() {
    this.createCard();
  }

  createCard() {
    if (this.project && this.project != null && this.project.ownerUser) {
      this.imageStyle = this.setImageCard(this.project, this.project.ownerUser);
    } else {
      this.imageStyle = null;
    }
  }

  setImageCard(project: ProjectSummaryResponse, user: string) {
    if (
      project.attributes?.primaryImage !== undefined &&
      project.attributes?.primaryImage !== null &&
      project.attributes?.primaryImage !== "image12"
    ) {
      return this.imageUrlService.projectStyle(user, project.projectID, project.attributes.primaryImage, 'inauguration');
    } else {
      return 'url("' + DEFAULT_IMAGE.href + '")';
    }
  }

  goProjectDetail() {
    if (this.project)
      this.router.navigate(["/project/", this.project.projectID]);
  }

  getSharedProject() {
    if (this.shared == true) {
      this.goProjectDetail();
    } else {
      this.actionFromCard.emit();
    }
  }

  toggleFavoriteProject() {
    if (this.shared == true) {
    } else {
      this.toggleFavoriteButton.emit();
    }
  }
}
